import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { ShowErrorFlag } from '@helpcenter/flags';
import { showErrorFlag } from '@helpcenter/flags';
import fetchModel from 'epics/model/fetcher';
import type {
	FetchTimezonesAction,
	FetchTimezoneRegionsAction,
	FetchTimezoneRegionsSuccess,
	FetchTimezonesSuccess,
} from 'state/actions/timezones';
import {
	FETCH_TIMEZONES_MODEL,
	FETCH_TIMEZONE_REGIONS_MODEL,
	fetchTimezoneRegionsSuccess,
	fetchTimezonesSuccess,
} from 'state/actions/timezones';
import { genericError } from 'utils/errors';
import type { ErrorResponse } from 'epics/model/types';

export const timezonesEpic: Epic<FetchTimezonesAction, FetchTimezonesSuccess | ShowErrorFlag> = (
	action$,
) => {
	return action$.ofType(FETCH_TIMEZONES_MODEL).mergeMap((action) =>
		fetchModel(action.payload)
			.filter((response) => !!response.timezones)
			.map((response) => {
				return fetchTimezonesSuccess(response.timezones || []);
			})
			.catch((_: ErrorResponse) => {
				return Observable.of(showErrorFlag(genericError.title, genericError.description));
			}),
	);
};

export const timezoneRegionsEpic: Epic<
	FetchTimezoneRegionsAction,
	FetchTimezoneRegionsSuccess | ShowErrorFlag
> = (action$) => {
	return action$.ofType(FETCH_TIMEZONE_REGIONS_MODEL).mergeMap((action) =>
		fetchModel(action.payload)
			.filter((response) => !!response.timezoneRegions)
			.map((response) => {
				return fetchTimezoneRegionsSuccess(response.timezoneRegions || []);
			})
			.catch((_: ErrorResponse) => {
				return Observable.of(showErrorFlag(genericError.title, genericError.description));
			}),
	);
};
